import React from 'react';
import { Col, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Funnel } from 'lucide-react';
import * as S from './styled';

export type FilterProps = {
    onReset?: () => void;
    loading?: boolean;
    children?: React.ReactNode;
    actionsAlign?: 'left' | 'right';
    justify?: 'start' | 'space-between';
};

export function FilterBlock({
    onReset,
    loading,
    children,
    actionsAlign = 'left',
    justify = 'space-between',
}: FilterProps) {
    return (
        <S.FilterArea>
            <S.FilterHeader>
                <Funnel size={14} strokeWidth={3} />
                <S.FilterTitle>FILTROS</S.FilterTitle>
            </S.FilterHeader>
            <S.RowStyled gutter={[16, 8]} align="top" justify={justify} wrap>
                {children}
                <Col span={24}>
                    <S.Actions $align={actionsAlign}>
                        <Space>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                                loading={loading}
                            >
                                Pesquisar
                            </Button>
                            <Button onClick={() => onReset?.()}>Limpar</Button>
                        </Space>
                    </S.Actions>
                </Col>
            </S.RowStyled>
        </S.FilterArea>
    );
}
